import { Modal } from "antd";
import React from "react";
import useModalStore from "./../../zustand/store/useModalStore";

function GlobalModal({ id, title, children }) {
  const { openModal, closeModal, isModalVisible } = useModalStore((state) => ({
    openModal: state.openModal,
    closeModal: state.closeModal,
    isModalVisible: (id) => state.isModalVisible(id),
  }));

  const handleCancel = () => {
    closeModal(id);
  };

  return (
    <Modal
      title={title}
      open={isModalVisible(id)}
      maskClosable={false}
      onCancel={handleCancel}
      destroyOnClose={true}
      footer={null}
    >
      {children}
    </Modal>
  );
}

export default GlobalModal;
